import { render, staticRenderFns } from "./delete_milestone_modal.vue.js?vue&type=template&id=a7c2f4e8&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete_milestone_modal.vue?vue&type=template&id=a7c2f4e8&vue3"
import script from "./delete_milestone_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete_milestone_modal.vue?vue&type=script&lang=js&vue3"
export * from "./delete_milestone_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete_milestone_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports